import { UiSchema } from '@rjsf/utils';
import { VFC } from 'react';

import { ChangeValue } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateVisualVersionDiff/types';
import { ValueDiffLabel } from 'dashboard/apps/InquiryTemplateEditor/ValueDiffLabel';
import { PropertyRow } from 'dashboard/apps/InquiryTemplateEditor/VersionDiffTable';
import { WorkflowActionFromConfig } from 'dashboard/models/workflow-version';

interface WorkflowActionDiffCheckboxProps {
  actionParameters: WorkflowActionFromConfig['params'];
  schema: UiSchema;
  schemaKey: string;
  parameterDiff: ChangeValue | null;
}

const WorkflowActionDiffCheckbox: VFC<WorkflowActionDiffCheckboxProps> = ({
  actionParameters,
  schema,
  schemaKey,
  parameterDiff,
}) => {
  const handleBarValue = parameterDiff ? (
    <ValueDiffLabel
      valueDiff={{
        added: parameterDiff.value,
        removed: parameterDiff['prev-value'],
      }}
      fallbackValue='None'
      vertical
    />
  ) : (
    String(actionParameters[schemaKey])
  );

  return (
    <>
      <PropertyRow textKey={schema['ui:title']!} value={handleBarValue} />
    </>
  );
};

export default WorkflowActionDiffCheckbox;
